import {LanguageService} from './services/language.service';
import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IdleReloadServiceService} from './services/idle-reload-service.service';
import {SwUpdate} from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  // Configure translation service
  constructor(
    private translate: TranslateService,
    private languageService: LanguageService,
    private idleReloadService: IdleReloadServiceService,
    private swUpdate: SwUpdate
  ) {
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
    this.idleReloadService.start(10);

    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        this.swUpdate.activateUpdate().then(() => document.location.reload());
      });
    }
  }
}
